import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { API_ADD_TO_CART, API_GET_PRODUCT_INFO } from "../modals/Constants";
import HeaderView from "../other-components/HeaderView/view";
import { getStorage, setStorage } from "../modals/Storage";
import ImageLoader from "../other-components/ImageLoader";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";

import AlertDialog from "../dialogs/AlertDialog/dialog";
import AddToCartDialog from "../dialogs/AddToCartDialog/dialog";
import ShareDialog from "../dialogs/ShareDialog/dialog";

import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import Collapsible from "../other-components/CollapsibleView/CollapsibleView";
import CollapsibleOptionView from "../other-components/CollapsibleOptionView/CollapsibleOptionView";

import HeroCarousel from "../other-components/HeroCarousel/View";
import Button from "../UI/Button/ui";
import SpecialMessageView from "../other-components/SpecialMessageView/view";
import FooterView from "../other-components/FooterView/view";

function ViewProduct() {
  const navigate = useNavigate();
  let { urlParam } = useParams();
  const containerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [searchParams] = useSearchParams();
  const specificProduct = searchParams.get("s") || "";

  const [loading, setLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState("");
  const [optionsDialog, setAddToCartDialog] = useState(false);
  const [shareDialog, setShareDialog] = useState(false);
  const [alertDialog, setAlertDialog] = useState(false);

  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  const [values, setConstants] = useState({
    dataLoaded: false,
  });

  const [productDetails, setProductDetails] = useState({
    productId: "",
    productName: "",
    productDescription: "",
    productHighlights: "",
    productBrand: "",
    productPrice: 0,
    productFinalPrice: 0,
    productOffer: 0,
    productTrend: 0,
    productPricingHtml: "",
    productSlugURL: "",
    productReturnPolicy: "",
    productSizes: [],
    productTags: [],
    productImages: [],
  });

  function loadRecords() {
    const fecthApiData = async (url, formData) => {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });
        const data = await res.json();
        setLoading(false);

        if (data.status_code == "success") {
          setStorage("app_special_message", data.special_message);
          setStorage("app_whatsapp_support_url", data.whatsapp_support_url);

          setConstants((previousState) => {
            return {
              ...previousState,
              dataLoaded: true,
            };
          });

          setProductDetails({
            ...productDetails,
            productId: data.data.item_id,
            productName: data.data.item_name,
            productPrice: data.data.item_price,
            productFinalPrice: data.data.item_final_price,
            productSizes: data.data.item_sizes,
            productOffer: data.data.item_offer,
            productDescription: data.data.item_description,
            productReturnPolicy: data.data.item_return_policy,
            productHighlights: data.data.item_highlights,
            productImages: data.data.item_media,
            productTags: data.data.item_tags,
            productTrend: data.data.item_trends
          });

          setIsDataLoaded(true);
        }
      } catch (error) {
        setLoading(false);
      }
    };

    if (!isDataLoaded) {
      setLoading(true);

      const formData = {
        ACCOUNT_ID: getStorage("accountID"),
        PRODUCT_SLUG: urlParam,
        PRODUCT_SPECIFIC: specificProduct
      };

      fecthApiData(API_GET_PRODUCT_INFO, formData);
    }
  }

  const addToBag = (size) => {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code == "success") {
          setStorage("app_cart_items", data.total_cart_records);
        } else if (data.status_code == "already_exist") {
          setAlertDialog(true);
        }
      } catch (error) {
        setLoading(false);
      }
    }

    if (getStorage("accountID") != "" && urlParam != "") {
      if (size == "") {
        size = "freesize";
      }
      setLoading(true);

      const formData = {
        ACCOUNT_ID: getStorage("accountID"),
        PRODUCT_ID: productDetails.productId,
        PRODUCT_SIZE: size,
      };
      requestAPI(API_ADD_TO_CART, formData);
    } else {
      navigate("/signin", { replace: true });
    }
  };

  useEffect(() => {
    if (urlParam != "") {
      loadRecords();

      resetTimeout();
    }

    return () => {
      resetTimeout();
    };
  }, [productDetails.productImages]);

  useEffect(() => {
    const container = containerRef.current;

    const handleScroll = () => {
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;

      // const reachedBottom =
      //   scrollTop + clientHeight >= scrollHeight - 5;
      const reachedBottom = ((scrollTop + clientHeight) / scrollHeight) * 100;
      if (reachedBottom >= 85 && !isAtBottom) {
        setIsAtBottom(true);
      } else if (reachedBottom < 85 && isAtBottom) {
        setIsAtBottom(false);
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [isAtBottom]);

  return (
    <div className={[general.appView]}>
      <LoadingDialog isOpen={loading} />

      <AddToCartDialog
        isOpen={optionsDialog}
        title="Select variant"
        options={productDetails.productSizes}
        onClose={() => setAddToCartDialog(false)}
        actions={[
          { label: "Cancel", variant: "neutral", onClick: () => setAddToCartDialog(false) },
          {
            label: "Add to cart",
            variant: "positive",
            onClick: (option) => {
              setAddToCartDialog(false);
              addToBag(option.value);
            }
          }
        ]}
      />

      <AlertDialog
        isOpen={alertDialog}
        title={"Item already in cart"}
        description={"You’ve already added this product to your cart."}
        onClose={() => setAlertDialog(false)}
        actions={[
          { label: "Close", variant: "neutral", onClick: () => setAlertDialog(false) }
        ]}
      />

      <ShareDialog
        isOpen={shareDialog}
        title="Share via"
        onClose={() => setShareDialog(false)}
        actions={[
          { label: "Cancel", variant: "neutral", onClick: () => setShareDialog(false) },
        ]}
      />

      <div className={[general.appChildView]} ref={containerRef}>
        <SpecialMessageView />
        <HeaderView />

        <div className={[general.appContentsView, general.mgT30px].join(" ")}>
          {values.dataLoaded && (
            <div className={[screen.productView]}>
              <HeroCarousel slides={productDetails.productImages} />

              <div className={[screen.productDetails]}>
                <label className="ft-sz-12">Home / {urlParam}</label>

                <h1 className={[screen.titleView, general.mgT5px].join(" ")}>
                  {productDetails.productName}
                </h1>

                {productDetails.productTrend > 0 && (
                  <p className={[general.rowView, general.colorGreen, general.fontSize15px, general.fontWgt500, general.mgT5px].join(" ")}>
                    <span className="material-symbols-outlined">
                      trending_up
                    </span>
                    &nbsp;
                    {productDetails.productTrend} recent purchases
                  </p>
                )}

                {/* <div className={[screen.reviewRatingsView, general.mgT5px].join(" ")}>
                  <div className={[screen.reviewRatings]}>
                    <ImageLoader className={[screen.icon]}
                      src={require("../media/icons/icon_star.png")}
                      alt="icon"
                    />
                    4.2
                  </div>

                  <label>3 ratings</label>
                </div> */}


                <div className={[screen.pricingView, general.mgT30px].join(" ")}>
                  <div>
                    <span className="ft-sz-25 ft-wgt-600">
                      ₹{productDetails.productFinalPrice}
                    </span>
                    <s
                      className={`ft-sz-15 mg-l-5 ${productDetails.productOffer <= 0 ? "hide-v" : ""
                        }`}
                    >
                      ₹{productDetails.productPrice}
                    </s>

                    {Number(productDetails.productOffer) > 0 && (
                      <span className={[general.colorGreen, general.fontWgt500, general.mgL10px].join(" ")}>
                        {productDetails.productOffer}% OFF
                      </span>
                    )}
                  </div>


                  <span className="ft-sz-12 mg-t-5">
                    inclusive of all taxes
                  </span>
                </div>

                <div className={[screen.controlView, isAtBottom && screen.hidden].filter(Boolean).join(" ")}>
                  <Button text="Add to cart"
                    rounded={true}
                    fullWidth={true}
                    hoverEffect={true}
                    action={{ onClick: () => setAddToCartDialog(true) }} />

                  <Button
                    text="Share"
                    icon={"ios_share"}
                    appearance={2}
                    rounded={true}
                    fullWidth={true}
                    spaceLeft={10}
                    action={{ onClick: () => setShareDialog(true) }} />
                </div>

                <CollapsibleOptionView title="Available Sizes" options={productDetails.productSizes} className={[general.mgT25px]} defaultOpen={true} />

                <Collapsible title="Product Description" description={productDetails.productDescription} className={[general.mgT25px]} />

                <Collapsible title="Product Details" description={productDetails.productHighlights} className={[general.mgT25px]} defaultOpen={true} />

                <Collapsible title="Return and Exchange" description={productDetails.productReturnPolicy} className={[general.mgT25px]} />

                <CollapsibleOptionView title="Product Tags" options={productDetails.productTags} className={[general.mgT25px]} />

                <div className={[general.w100, general.viewCenter, general.mgT40px].join(" ")}>
                  <ImageLoader className={[general.heightWidth30px]}
                    src={require("../media/icons/icon_verified.png")}
                    alt="icon"
                  />
                  <p className={[general.colorLightBlack, general.fontSize14px, general.fontWgt600, general.mgL10px].join(" ")}>Safe & Secured Payments. 100% Authentic products.</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <FooterView />
      </div>
    </div>
  );
}

export default ViewProduct;
